import React, { createContext, useContext } from "react";

export type StatisticsPageErrorContextValue = {
  suppressWidgetErrors: boolean;
};

const StatisticsPageErrorContext = createContext<StatisticsPageErrorContextValue>({
  suppressWidgetErrors: false,
});

export function StatisticsPageErrorProvider({
  suppressWidgetErrors,
  children,
}: {
  suppressWidgetErrors: boolean;
  children: React.ReactNode;
}): React.ReactElement {
  return (
    <StatisticsPageErrorContext.Provider value={{ suppressWidgetErrors }}>
      {children}
    </StatisticsPageErrorContext.Provider>
  );
}

export function useStatisticsPageErrorContext(): StatisticsPageErrorContextValue {
  return useContext(StatisticsPageErrorContext);
}
